<template>
    <div class="window-wrapper window-auth">
        <div class="window-overlay"></div>
        <div class="window">
            <div class="window-inner">
                <div class="window-left">

                </div>
                <div class="window-right">
                    <div class="window-right-inner">
                        <div class="logo">
                            <Logo/>
                        </div>
                        <div class="title" v-html="$ml.with('VueJS').get('authTitle')"></div>
                        <div class="form">

                            <OAuth2Result/>

                            <fieldset class="form-field-input filled" v-bind:class="{'error-field' : errors.has('email') || this.errorsFields.email}">
                                <label>
                                    <input name="email"
                                           ref="email"
                                           v-model.trim="email"
                                           type="text"
                                           autocomplete="off"
                                           required
                                           v-validate="'required|email'"
                                           @input="errorsFields.email = false"
                                           @keyup.enter="login">
                                    <div class="label-text">Email</div>
                                    <div v-show="errors.has('email')" class="msg-form msg-error-field">{{
                                        errors.first('email') }}
                                    </div>
                                    <div v-show="errorsFields.email"
                                         class="msg-form msg-error-field" v-html="$ml.with('VueJS').get('errors.custom.email.emailNotFoundError')">
                                    </div>


                                </label>
                            </fieldset>

                            <fieldset class="form-field-input filled" v-bind:class="{'error-field' : errors.has('password') || this.errorsFields.password}">
                                <label>
                                    <input v-model="password"
                                           name="password"
                                           type="password"

                                           autocomplete="off"
                                           required
                                           v-validate="'required'"
                                           @keyup.enter="login"
                                           v-on:keydown="errorsFields.password = false"
                                           class="password-input dev-password">
                                    <div class="label-text" v-html="$ml.with('VueJS').get('password')"></div>
                                    <div class="password-input-change"></div>
                                    <div v-show="errors.has('password')" class="msg-form msg-error-field">{{
                                        errors.first('password') }}
                                    </div>
                                    <div v-show="errorsFields.password"
                                         class="msg-form msg-error-field"
                                         v-html="$ml.with('VueJS').get('errors.custom.password.passwordError')"
                                    >

                                    </div>

                                </label>
                            </fieldset>

                            <div class="window-form-row">
                                <div class="forgot-pass">
                                    <a href="#" class="modal-forgot"
                                       v-html="$ml.with('VueJS').get('passwordForgot')"></a>
                                </div>
                            </div>

                            <div class="button-block">
                                <button class="button button-dark"
                                        :disabled="isBlocked || pressed"
                                        @click="login"
                                        v-html="$ml.with('VueJS').get('signIn')"></button>


                                <button class="button button-border button-icon"  @click="googleLogin">
                                    <div class="icon">
                                        <svg width="18" height="18" viewBox="0 0 18 18" fill="none"
                                             xmlns="http://www.w3.org/2000/svg">
                                            <path fill-rule="evenodd" clip-rule="evenodd"
                                                  d="M17.64 9.2C17.64 8.563 17.583 7.949 17.476 7.36H9V10.841H13.844C13.635 11.966 13.001 12.919 12.048 13.558V15.816H14.956C16.658 14.249 17.64 11.942 17.64 9.201V9.2Z"
                                                  fill="#4285F4"/>
                                            <path fill-rule="evenodd" clip-rule="evenodd"
                                                  d="M9.00302 18C11.433 18 13.47 17.194 14.959 15.82L12.05 13.56C11.244 14.1 10.214 14.42 9.00302 14.42C6.65902 14.42 4.67502 12.836 3.96702 10.709H0.960022V13.041C2.44002 15.983 5.48502 18 9.00302 18Z"
                                                  fill="#34A853"/>
                                            <path fill-rule="evenodd" clip-rule="evenodd"
                                                  d="M3.964 10.712C3.784 10.172 3.682 9.59501 3.682 9.00201C3.682 8.40901 3.784 7.83201 3.964 7.29201V4.96001H0.957C0.347 6.17501 0 7.55001 0 9.00201C0 10.454 0.348 11.829 0.957 13.044L3.964 10.712Z"
                                                  fill="#FBBC05"/>
                                            <path fill-rule="evenodd" clip-rule="evenodd"
                                                  d="M9.00302 3.58C10.324 3.58 11.511 4.034 12.443 4.925L15.025 2.345C13.464 0.891 11.428 0 9.00202 0C5.48502 0 2.44002 2.017 0.960022 4.958L3.96702 7.29C4.67502 5.163 6.65902 3.58 9.00302 3.58Z"
                                                  fill="#EA4335"/>
                                        </svg>
                                    </div>
                                    <div class="text"
                                         v-html="$ml.with('VueJS').get('signInWithGoogle')"></div>
                                </button>
                                <div class="agreemet-text">Авторизуясь с помощью соц. сетей вы соглашаетесь с условиями обработки <router-link :to="{name: 'PrivacyPolicy'}" target="_blank">персональных данных</router-link> и с <router-link target="_blank" :to="{name:'TermsOfUse'}">пользовательским соглашением</router-link></div>
                            </div>

                        </div>

                        <div class="reg-block">
                            <div class="reg-text" v-html="$ml.with('VueJS').get('notSignUpYet')">
                            </div>
                            <button class="button button-border modal-reg"
                                    v-html="$ml.with('VueJS').get('signUpTitle')"></button>
                        </div>

                    </div>
                </div>
            </div>
            <button class="btn-close">
                <svg viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g>
                        <path d="M1 1L27 27M27 1L1 27" stroke="black"/>
                    </g>
                </svg>
            </button>
        </div>
    </div>
</template>



<script>

    import {Validator} from 'vee-validate';
    import Logo from "../icons/Logo";

    import constants from '@/constants';
    import OAuth2Result from "../OAuth2Result";
    import {MLBuilder} from 'vue-multilanguage';


    export default {
        name: 'Login',
        components: {OAuth2Result, Logo, constants},
        data() {
            return {
                errorsFields: {
                   email: false,
                   password: false
                },
                email: '',
                password: '',
                isNoAccess: false,
                pressed: false
            }
        },


        mounted() {


            $('.dev-password').bind('paste', function (e) {
                e.preventDefault();
                return false;
            });

            // password visibility toggle
            $('.password-input-change').click(function(){
                if( $(this).hasClass('visible') ) {
                    $(this).parent().find('input.password-input').attr('type','password');
                    $(this).removeClass('visible');
                } else {
                    $(this).parent().find('input.password-input').attr('type','text');
                    $(this).addClass('visible');
                }
            });
        },

        computed: {
            isBlocked() {
                return !(Object.keys(this.fields).every(key => this.fields[key].valid))
            }
        },

        methods: {

             async login() {
                this.pressed = true;
                if (!!this.isBlocked) {
                    this.pressed = false;
                    return;
                }
                let userAuth = {
                    username: this.email,
                    password: this.password,
                    language: this.$ml.current
                };
                let error =  await this.$store.dispatch('authorization', userAuth);
                if (error) {
                    if (error === 'email') {
                        this.errorsFields.email = true;
                    }
                    if (error === 'password') {
                        this.errorsFields.password = true;
                    }
                } else {
                    await this.$store.dispatch('changeLanguage', this.$ml.current);
                }
                this.pressed = false;

            },

            googleLogin() {
                window.location.href = constants.GOOGLE_AUTH_URL;
            }
        }
    }
</script>